import { shallowEqual, useSelector } from "react-redux";
import { ApplicationState } from "../reducers";

export function useSelectorShallow<TSelected>(selector: (state: ApplicationState) =>TSelected):TSelected{
    return useSelector(selector, shallowEqual);
}